<template>
    <div :class="{ disabled: isSaving }">
        <div class="listing-header mb-4">
            <div class="title-breadcrumb">
                <div
                    class="notification is-danger is-light p-3 mr-4"
                    v-if="countContratoLpsInativos != 0"
                >
                    {{ $t('existem-registros-inativos-ajuste') }}
                </div>
            </div>
            <div class="header-buttons">
                <button
                    v-if="permissao.update"
                    @click="save()"
                    :disabled="isSaving || countContratoLpsInativos != 0"
                    class="save-btn"
                    type="button"
                >
                    {{ $t('salvar') }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>
        <!-- SEMANAL -->
        <div class="aba-itinerario">
            <div class="week">
                <div class="days" v-for="(dia, index) in dias" :key="index">
                    <ItinerarioDayList
                        :dia="dia"
                        :onLpsRemove="onLpsRemove"
                        :onLpsDetail="openContratoLpsModal"
                        :onAdd="adicionarAssociacao"
                        :onRemove="openModalExcluirAssociacao"
                        :onTransfer="openTransferDupeModal"
                        :onDuplicate="duplicateDays"
                        :onLocation="loadMarkers"
                    />
                </div>
            </div>
        </div>

        <b-modal :active.sync="showContratoLpsModal">
            <div class="bg">
                <ContratoLpsModal
                    :selectedLps="selectedLps"
                    @fecharModal="fecharModal"
                    @updateContratoLps="updateContratoLps"
                />
            </div>
        </b-modal>

        <lateral-content v-model="showTransferDupeModal" :title="$t('copiar-transferir-itinerario')" compact header headerHideClose footer>
            <container-loader v-if="isLoadingAtendimentos" />
            <div class="p-4">
                <span>
                    <vss-select
                        title="promotor"
                        v-model="promotorSelected"
                        :options="promotorSelect"
                        :loading="isPromotorLoading"
                        @search="loadPromotor"
                        searchable
                        required
                        placeholder="selecione"
                    />
    
                    <vss-select
                        title="dia-da-semana"
                        class="mb-4"
                        v-model="diaSelected"
                        :options="dias"
                        required
                        label="nome"
                        mlLabels
                        :disabled="promotorSelected === null"
                        placeholder="selecione"
                    />
                </span>
                
                <ItinerarioDayList
                    v-if="diaToTranferDupe"
                    :dia="diaToTranferDupe"
                    :lpssSelected="lpssSelected"
                    :setLpssSelected="setLpssSelected"
                    checkVariation
                />
            </div>

            <template v-slot:footer-right>
                <b-button
                    type="is-primary"
                    icon-right="content-duplicate"
                    class="mr-2"
                    @click="() => parseSelectedLpssToDay(true)"
                    :disabled="lpssSelected.length < 1"
                >
                    {{ $t('transferir') }}
                </b-button>
                <b-button
                    type="is-primary"
                    icon-right="content-copy"
                    @click="() => parseSelectedLpssToDay(false)"
                    :disabled="lpssSelected.length < 1"
                >
                    {{ $t('copiar') }}
                </b-button>
            </template>
        </lateral-content>

        <lateral-content v-model="showModal" :title="$t(dias[mapDay].nome)" header>
            <Mapa
                ref="Mapa"
                :dias="dias"
                :mapDay="mapDay"
                :mapcenter="mapcenter"
                :lpsList="lpsList"
            />
        </lateral-content>

        <div class="modal" v-if="modalOpen">
            <modal-container :val="modalValue" :list="dias" :containerName="modals[index]" />
        </div>
    </div>
</template>

<script>
import Mapa from '@/components/promotor/rota/abas/Mapa.vue';
import ContratoLpsModal from '@/components/promotor/rota/modal/ContratoLpsModal.vue';
import ProLpsService from '@/services/promotor/ProLpsService.js';
import ProAssRotaContratoLpsService from '@/services/promotor/ProAssRotaContratoLpsService.js';
import Message from '@/models/Message.js';
import ItinerarioDayList from '@/components/promotor/rota/components/ItinerarioDayList.vue';
import ContainerLoader from "@/components/content/loader/ContainerLoader";

export default {
    components: {
        Mapa,
        ContratoLpsModal,
        ItinerarioDayList,
        ContainerLoader
    },
    props: {
        permissao: {
            type: Object,
            default: () => {},
        },
        rota: null,
    },
    watch: {
        showTransferDupeModal(isBeenShowed) {
            if(isBeenShowed) {
                this.promotorSelected = null;
                this.diaSelected = null;
                this.diaToTranferDupe = null;
            }
        },
        promotorSelected(newPromotorSelected) {
            this.lpssSelected = [];
            
            if(this.diaSelected) 
                this.loadAtendimentosFromAnotherPromotor(newPromotorSelected.id, this.diaSelected.dataatendimento);
        },
        diaSelected(newDiaSelected) {
            this.lpssSelected = [];

            if(newDiaSelected) 
                this.loadAtendimentosFromAnotherPromotor(this.promotorSelected.id, newDiaSelected.dataatendimento);
        }
    },
    data() {
        return {
            isSaving: false,
            lpsservice: new ProLpsService(this.$http, this.$router),
            proAssRotaContratoLpsService: new ProAssRotaContratoLpsService(
                this.$http,
                this.$router
            ),
            duplicateTo: {
                periodo: 7,
                days: [],
            },
            modalValue: null,
            modals: ['SelectLPS', 'DuplicarDia'],
            modalOpen: false,
            index: 0,

            selectedDay: null,
            showModal: false,
            showContratoLpsModal: false,
            showTransferDupeModal: false,
            selectedLps: {
                idLps: 0,
                nomeLps: "",
                contratos: []
            },
            lpsList: [],
            proAssRotaContratoLpsList: [],
            promotorSelected: null,
            promotorSelect: null,
            isPromotorLoading: false,
            diaSelected: null,
            diaToTranferDupe: null,
            contratosToDelete: [],
            proAssRotaContratoLpsListOrdenada: [],
            dias: [
                {
                    id: 0,
                    nome: 'domingo',
                    lpss: [],
                    dataatendimento: this.getDataAtendimento(0),
                },
                {
                    id: 1,
                    nome: 'segunda',
                    lpss: [],
                    dataatendimento: this.getDataAtendimento(1),
                },
                {
                    id: 2,
                    nome: 'terca',
                    lpss: [],
                    dataatendimento: this.getDataAtendimento(2),
                },
                {
                    id: 3,
                    nome: 'quarta',
                    lpss: [],
                    dataatendimento: this.getDataAtendimento(3),
                },
                {
                    id: 4,
                    nome: 'quinta',
                    lpss: [],
                    dataatendimento: this.getDataAtendimento(4),
                },
                {
                    id: 5,
                    nome: 'sexta',
                    lpss: [],
                    dataatendimento: this.getDataAtendimento(5),
                },
                {
                    id: 6,
                    nome: 'sabado',
                    lpss: [],
                    dataatendimento: this.getDataAtendimento(6),
                },
            ],
            mapcenter: {
                lat: -24.9592027,
                lng: -53.4608336,
                nome: 'Cascavel',
                tipo: 'cidade',
            },
            mapDay: 0,
            countContratoLpsInativos: 0,
            lpssSelected: [],
            isLoadingAtendimentos: false
        };
    },
    created() {
        this.$on('update-lps', this.updateLps);
        this.$on('duplicate-data', this.duplicarRotaDia);
        this.$on('delete', this.excluirAssociacao);

        this.setaCoordenadas();
        this.carregarDados();
    },
    methods: {
        setLpssSelected(lpssSelected) {
            this.lpssSelected = lpssSelected;
        },
        addToDeletedLpss(contratosToBeChecked) {
            const contratosNotYetIncludedInDelete = 
                contratosToBeChecked.filter(contrato => 
                    !this.contratosToDelete.some(contratoToDelete => contratoToDelete.idproassrotacontratolps === contrato.idproassrotacontratolps)) 

            this.contratosToDelete = [
                ...this.contratosToDelete,
                ...contratosNotYetIncludedInDelete
            ]
        },
        parseSelectedLpssToDay(isTransfer) {
            this.$emit('isChanged', true);

            this.showTransferDupeModal = false;

            if(isTransfer) {
                const contratos = this.lpssSelected
                    .map(({contratos}) => (contratos))
                    .flat();

                this.addToDeletedLpss(contratos);
            }

            this.lpssSelected = this.lpssSelected.map(lps => {
                const contratosMappedToInsert = lps.contratos.map(({idproassrotacontratolps, ...rest}) => {
                    return {
                        idproassrotacontratolps: null,
                        ...rest
                    };
                })

                lps.contratos = contratosMappedToInsert;
                
                return lps;
            });

            const currentLpssInDay = this.dias[this.selectedDay].lpss;

            const idsLpssInDay = currentLpssInDay.map(({id}) => id);

            const [newLpss, lpssAlreadyInDay] = this.separateExistingAndNewLpss(this.lpssSelected, idsLpssInDay);

            const LpssWithUpdatedContratos = lpssAlreadyInDay.map((lpsToBeAdded) => {
                const lpsAlreadyInDay = currentLpssInDay.find(lpsInDay => lpsInDay.idlps === lpsToBeAdded.idlps);

                const onlyNewContratos = 
                    lpsToBeAdded.contratos
                        .filter(contratoToBeAdd => 
                            !lpsAlreadyInDay.contratos.some(
                                contratoAlreadyInDay => 
                                    contratoAlreadyInDay.proContratoLps.contrato.id === contratoToBeAdd.proContratoLps.contrato.id
                        ));
                
                lpsToBeAdded.contratos = [
                    ...lpsAlreadyInDay.contratos,
                    ...onlyNewContratos
                ]

                return lpsToBeAdded;
            })

            const idsLpssAlreadyInDay = lpssAlreadyInDay.map(({id}) => id);

            const lpssInDayNotUpdated = currentLpssInDay.filter((lps) => !idsLpssAlreadyInDay.includes(lps.id));

            this.dias[this.selectedDay].lpss = [
                ...lpssInDayNotUpdated,
                ...LpssWithUpdatedContratos,
                ...newLpss
            ]

            this.lpssSelected = []
        },
        separateExistingAndNewLpss(lpssSelected, idLpssInDay) {
            const newLpss = [];
            
            const lpssAlreadyInDay = lpssSelected.filter(lpsSelected => {
                if(idLpssInDay.includes(lpsSelected.idlps)) {
                    return true
                }

                newLpss.push(lpsSelected);
            })

            return [newLpss, lpssAlreadyInDay]
        },
        loadAtendimentosFromAnotherPromotor(idPromotor, dataAtendimento) {
            this.isLoadingAtendimentos = true;

            this.$axios
                .get(`/promotor/ass-rota-contrato-lps/by-promotor/${idPromotor}.json`,
                    {
                        params: {
                            dataAtendimento
                        }
                    }
                )
                .then((response) => {
                    const lpssMapped = [];

                    const idsContratosDeleted = this.contratosToDelete.map(({id}) => id);

                    const contratosNotDeleted = response.data.content.filter(contrato => !idsContratosDeleted.includes(contrato.idproassrotacontratolps));

                    contratosNotDeleted.forEach((proAssRotaContratoLps) => {
                        let lps = proAssRotaContratoLps.proContratoLps.lps;

                        lps = lpssMapped.filter((l) => l.idlps == lps.idlps)[0] || lps;

                        if (!lps.contratos) {
                            lps.contratos = [];
                            lpssMapped.push(lps);
                        }

                        lps.contratos.push(proAssRotaContratoLps);

                        proAssRotaContratoLps.proContratoLps.lps = null;
                    });
                    

                    this.diaToTranferDupe = {
                        ...this.diaSelected,
                        lpss: lpssMapped
                    };
                })
                .catch((e) => {
                    this.$root.showMessage("error", "msg-erro-load");
                })
                .finally(() => {
                    this.isLoadingAtendimentos = false;
                });
        },
        loadPromotor(searchValue) {
            this.isPromotorLoading = true;

            this.$axios.get("/employees.json", {
                params: {
                    page: 0,
                    limit: 25,
                    column: 'nome',
                    order: 'asc',
                    situacao: 1,
                    param: searchValue
                }
            })
            .then((response) => {
                this.promotorSelect = response.data.content
                .filter(promotor => promotor.id != this.rota.usuario.id)
                .map(promotor => ({
                    id: promotor.id,
                    label: promotor.nome
                }));
            })
            .catch((e) => {
                this.$root.showMessage("error", "msg-erro-load");
            })
            .finally(() => {
                this.isPromotorLoading = false;
            });
        },
        carregarDados() {
            this.$store.commit('addLoader');
            this.proAssRotaContratoLpsService
                .getAllByRota(this.$route.params.id)
                .then((body) => {
                    this.proAssRotaContratoLpsList = body.content;

                    this.proAssRotaContratoLpsList.forEach((proAssRotaContratoLps) => {
                        if (proAssRotaContratoLps.proContratoLps == undefined) {
                            console.warn(
                                'ROTACONTRATOLPS sem associação CONTRATOLPS.',
                                `IDASSROTACONTRATOLPS: ${proAssRotaContratoLps.idproassrotacontratolps}`
                            );
                        } else if (proAssRotaContratoLps.proContratoLps.lps == undefined) {
                            console.warn(
                                'ROTACONTRATOLPS sem LPS associada.',
                                `IDASSROTACONTRATOLPS: ${proAssRotaContratoLps.idproassrotacontratolps}\n` +
                                    `IDCONTRATOLPS: ${proAssRotaContratoLps.proContratoLps.idcontratolps}\n` +
                                    `IDCONTRATO: ${proAssRotaContratoLps.proContratoLps.contrato.idcontrato}`
                            );
                        }

                        // ajusta para o GMT do pc
                        let temp = this.$moment(proAssRotaContratoLps.dataatendimento, 'YYYY-MM-DD').toDate()

                        let dia = this.dias[this.$moment(temp).day()];
                        let lps = proAssRotaContratoLps.proContratoLps.lps;
                        // agrupa as LPS desse dia para juntas os contratos vínculados
                        lps = dia.lpss.filter((l) => l.idlps == lps.idlps)[0] || lps;

                        if (!lps.contratos) {
                            lps.contratos = [];
                            dia.lpss.push(lps);
                        }

                        lps.contratos.push(proAssRotaContratoLps);
                        proAssRotaContratoLps.proContratoLps.lps = null;
                    });
                })
                .finally((_) => {
                    this.inativos();
                    this.$store.commit('removeLoader');
                });
        },
        duplicateDays(selectedDay) {
            this.selectedDay = selectedDay;
            this.duplicateTo.days = [selectedDay];
            this.duplicateTo.periodo = this.rota.periodo;
            this.openModal(
                this.duplicateTo,
                this.modals.findIndex((v) => v == 'DuplicarDia')
            );
        },
        openContratoLpsModal(lps, index, dia) {
            this.selectedLps = { lps, index, dia };

            this.showContratoLpsModal = true;
        },
        openTransferDupeModal(selectedDay) {
            this.selectedDay = selectedDay;

            this.showTransferDupeModal = true;
        },
        fecharModal() {
            this.lpssSelected = [];

            this.showContratoLpsModal = false;
        },
        onLpsRemove(dia, index) {
            this.$emit('isChanged', true);

            this.contratosToDelete =
                this.contratosToDelete
                    .filter(contrato => 
                        !dia.lpss[index].contratos
                        .some(contratoBeenRemoved => 
                            contratoBeenRemoved.id === contrato.idproassrotacontratolps));

            dia.lpss.splice(index, 1);

            this.inativos();
        },
        openModalExcluirAssociacao(dia) {
            let weekday = this.$moment(dia % 7, 'e').format('dddd');
            let weekdate = this.$moment().day(dia).format('L');
            this.modalValue = dia;

            this.$root.confirm({
                message: this.$t('msg-excluir-lps-rota-n', { n: `${weekday} (${weekdate})` }),
                onConfirm: this.excluirAssociacao,
            });
        },
        excluirAssociacao() {
            this.$emit('isChanged', true);

            if (this.dias[this.modalValue]) {
                this.dias[this.modalValue].lpss = [];
            }
            this.inativos();

            this.modalValue = null;
        },
        openModal(value, index) {
            this.modalOpen = !this.modalOpen;
            this.modalValue = value;
            this.index = index;
        },
        adicionarAssociacao(dia) {
            this.index = 0;
            this.modalValue = dia;
            this.modalOpen = true;
        },
        inativos() {
            this.countContratoLpsInativos = 0;
            for (let dia of this.dias) {
                for (let lps of dia.lpss) {
                    if (lps.situacao != 1 || lps.replicapda != 3) {
                        this.countContratoLpsInativos++;
                    } else {
                        for (let contrato of lps.contratos) {
                            if (
                                contrato.proContratoLps.situacao != 1 ||
                                contrato.proContratoLps.replicapda != 3
                            ) {
                                this.countContratoLpsInativos++;
                            }
                        }
                    }
                }
            }
        },
        updateContratoLps(value) {
            this.$emit('isChanged', true);

            this.dias[value.dia].lpss[value.index].contratos = value.lps.contratos;

            this.dias[value.dia].lpss = this.dias[value.dia].lpss.map(lps => lps);

            this.inativos();
        },
        updateLps(dias) {
            dias.forEach((dia) => {
                dia.lpss.forEach((lps) => {
                    if (!lps.contratos) {
                        this.$emit('isChanged', true);

                        lps.contratos = [];
                    }
                });
            });
            this.dias = dias;
            if (this.$refs.Mapa.$refs.gmapComponent) {
                this.$refs.Mapa.$refs.gmapComponent.$refs.mapRef.$mapPromise.then((map) => {
                    this.$refs.Mapa.$refs.gmapComponent.loadMarkers();
                });
            }
            this.inativos();
        },
        duplicarRotaDia(value) {
            this.$emit('isChanged', true);

            value.days.forEach((dia) => {
                if (dia != this.selectedDay) {
                    this.dias[dia].lpss = JSON.parse(
                        JSON.stringify(this.dias[this.selectedDay].lpss)
                    );

                    this.dias[dia].lpss.forEach((lps) => {
                        lps.contratos.forEach((contrato) => {
                            contrato.id = null;
                            contrato.idproassrotacontratolps = null;
                        });
                    });
                }
            });
        },
        setCurrentLatLong(position) {
            if (position && position.coords) {
                this.mapcenter = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                    tipo: 'cidade',
                };
            }
        },
        setaCoordenadas() {
            if (!this.isNull(this.rota.usuario)) {
                this.mapcenter = {
                    lat: this.rota.usuario.latitude,
                    lng: this.rota.usuario.longitude,
                    tipo: 'promotor',
                    id: this.rota.usuario.id,
                    nome: this.rota.usuario.nome,
                };
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(this.setCurrentLatLong);
                }
            }

            this.carregaLps();
        },

        carregaLps() {
            this.lpsservice
                .findByLatLong(0, 50, this.mapcenter.lat, this.mapcenter.lng)
                .then(this.mapLpsMarkers)
                .then((lps) => {
                    this.lpsList = lps;
                });
        },
        mapLpsMarkers(body) {
            return body.content.map((m) => {
                return {
                    id: m.id,
                    idlps: m.idlps,
                    lat: m.latitude,
                    lng: m.longitude,
                    tipo: 'lps',
                    endereco: m.endereco,
                    numero: m.numero,
                    bairro: m.bairro,
                    nome: m.nome,
                    situacao: m.situacao,
                    replicapda: m.replicapda,
                    selected: this.isMarkerSelected(m),
                };
            });
        },
        isMarkerSelected(lpsSelected) {
            this.dias.forEach((dia) => {
                dia.lpss.forEach((lps) => {
                    if (lps.idlps == lpsSelected.idlps) return true;
                });
            });
            return false;
        },
        loadMarkers(day) {
            this.mapDay = day;
            this.$refs.Mapa.$refs.gmapComponent.$refs.mapRef.$mapPromise.then((map) => {
                this.$refs.Mapa.$refs.gmapComponent.loadMarkers();
            });
            this.showModal = true;
        },
        getDataAtendimento(i) {
            return this.$moment().day(i).toDate();
        },
        save() {
            let lpsSemContrato = 0;
            this.isSaving = true;
            this.proAssRotaContratoLpsList = [];
            this.dias.forEach((dia, index) => {
                dia.lpss.forEach((lps) => {
                    if (this.isNull(lps.contratos) || lps.contratos.length == 0) {
                        lpsSemContrato++;
                        return;
                    }
                    lps.contratos.forEach((contrato) => {
                        contrato.dataatendimento = this.$moment().day(index).toDate();
                        contrato.idrota = this.$route.params.id;
                    });

                    this.proAssRotaContratoLpsList.push(...lps.contratos);
                });
            });

            this.ordenarproAssRotaContratoLpsList();
            if (lpsSemContrato != 0) {
                this.$root.msgs.push(new Message('alert', 'msg-lps-sem-contrato-rota', true));
                this.isSaving = false;
            } else {
                if(this.contratosToDelete) {
                    this.$axios.post('/promotor/ass-rota-contrato-lps/inactivate', this.contratosToDelete)
                }

                this.proAssRotaContratoLpsService
                    .save(this.proAssRotaContratoLpsList, this.$route.params.id)
                    .then((body) => {
                        console.log(body);
                        this.$root.msgs.push(new Message('success', 'msg-rota-edita', true));

                        this.$emit('isChanged', false);
                    })
                    .catch((e) => {
                        this.$root.msgs.push(
                            new Message('error', 'msg-problema-realizar-acao', true)
                        );
                    })
                    .finally((_) => {
                        this.isSaving = false;
                    });
            }
        },
        ordenarproAssRotaContratoLpsList(){
            
            if(this.proAssRotaContratoLpsList != null && this.proAssRotaContratoLpsList.length > 0){
                let diaAtual = null;
                let sequenciaAtual = 0;


                this.proAssRotaContratoLpsList.forEach((obj) => {
                    const dia = new Date(obj.dataatendimento).toISOString().split("T")[0]; 

                    if (dia !== diaAtual) {
                        diaAtual = dia;
                        sequenciaAtual = 1;
                    } else {
                        sequenciaAtual++;
                    }

                    obj.sequencia = sequenciaAtual;
                });
            }

        }
    },
};
</script>

<style lang="scss" scoped>
.aba-itinerario {
    display: flex;
    position: relative;
    justify-content: space-between;
    flex-direction: column;
    margin-left: -15px;
    margin-right: -20px;
    border-radius: 6px;

    .week {
        margin-top: 20px;
        flex: 1 1 auto;
        width: 100%;
        overflow-y: hidden;
        display: flex;
        justify-content: flex-start;

        .days {
            width: 200px;
            min-height: 400px;
            display: flex;
            flex-direction: column;
            margin: 0 15px 10px;
            flex: 0 0 auto;
        }
    }
}
</style>
